import { connect } from "react-redux";
// Component
import ReplaceModal from "components/CreateSurvey/BaseWord/ReplaceModal";
// Action
import {
  openConfirmDialog,
  closeConfirmDialog
} from "redux/modules/confirmDialog";
import { showSnackbar } from "redux/modules/snackbar";
import {
  closeReplaceModal,
  replaceAllBaseWord
} from "redux/modules/createSurvey";

const mapStateToProps = state => ({
  replaceModal: state.createSurvey.replaceModal
});

const mapDispatchToProps = dispatch => ({
  // 閉じる
  handleClose: () => dispatch(closeReplaceModal()),
  replaceAll: keywords => {
    const dialogData = {
      title: "確認",
      contentText:
        "キーワードを基本設問のすべての設問文に適用します。よろしいですか？",
      btnLabel: "適用",
      handleClick: () => {
        dispatch(closeConfirmDialog());
        dispatch(closeReplaceModal());
        dispatch(replaceAllBaseWord(keywords));
        dispatch(showSnackbar("キーワードを適用しました。"));
      }
    };
    dispatch(openConfirmDialog(dialogData));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ReplaceModal);



// WEBPACK FOOTER //
// ./src/containers/CreateSurvey/BaseWord/ReplaceModalContainer.js